<template>
  <a-drawer title="标签管理" v-model:open="state.isShow" width="60%">
    <a-row class="mb10 df jcsb">
      <!-- <a-col :span="2" class="df aic">
          <span class="cursor" @click="back"> <LeftOutlined /> 返回上一页</span>
        </a-col> -->
      <a-col :span="5">
        <label class="mr10">系统:</label>
        <a-select
          placeholder="请选择"
          v-model:value="state.systemId"
          allowClear
          :filterOption="filterOption"
          show-search
          style="width:80%;"
        >
          <a-select-option
            :value="item.id"
            :name="item.name"
            v-for="item in state.systems"
            :key="item.name"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :span="5">
        <label class="mr10">类型:</label>
        <a-select
          allowClear
          placeholder="请选择"
          show-search
          style="width:80%;"
          v-model:value="state.type"
        >
          <a-select-option :value="1">无</a-select-option>
          <a-select-option :value="2">热门</a-select-option>
          <a-select-option :value="3">最新的</a-select-option>
        </a-select>
      </a-col>
      <a-col :span="5">
        <label class="mr10">状态:</label>
        <a-select
          allowClear
          show-search
          placeholder="请选择"
          style="width:80%;"
          v-model:value="state.status"
        >
          <a-select-option :value="0">已下架</a-select-option>
          <a-select-option :value="1">已上架</a-select-option>
        </a-select>
      </a-col>
      <a-col :span="7" class="tar mr20">
        <a-button size="small" type="primary" class="mr10" @click="getList"
          >查询</a-button
        >
        <a-button size="small" type="primary" @click="state.visible = true"
          >新建标签</a-button
        >
      </a-col>
    </a-row>
    <a-table
      size="small"
      rowKey="id"
      :pagination="false"
      bordered
      :dataSource="state.dataSource"
      :columns="columns"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'type'">
          <span>{{ state.typeObj[record.type] }}</span>
        </template>
        <template v-if="column.key === 'action'">
          <a-button
            type="link"
            size="small"
            v-if="record.status == 1"
            @click="setOffShelf(record.id)"
            >下架</a-button
          >
          <a-button
            type="link"
            size="small"
            v-else
            @click="setOnShelf(record.id)"
            >上架</a-button
          >
          <a-button type="link" size="small" @click="onDelete(record.id)"
            >删除</a-button
          >
          <a-button type="link" size="small" @click="onEdit(record)"
            >编辑</a-button
          >
        </template>
      </template>
    </a-table>
  </a-drawer>

  <a-modal v-model:open="state.visible" title="添加标签" @ok="submit">
    <a-form
      :model="formState"
      :rules="rules"
      ref="formRef"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 20 }"
    >
      <a-form-item label="系统:" name="systemId">
        <a-select
          placeholder="请选择"
          v-model:value="formState.systemId"
          allowClear
          :filterOption="filterOption"
          show-search
          @change="onChange"
        >
          <a-select-option
            :value="item.id"
            :name="item.name"
            v-for="item in state.systems"
            :key="item.name"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="标签类型:" name="type">
        <a-select v-model:value="formState.type">
          <a-select-option :value="1">无</a-select-option>
          <a-select-option :value="2">热门</a-select-option>
          <a-select-option :value="3">最新的</a-select-option>
        </a-select>
      </a-form-item>
      <!-- <a-form-item label="是否上架:" name="type">
        <a-select v-model:value="formState.status">
          <a-select-option :value="1">上架</a-select-option>
          <a-select-option :value="0">下架</a-select-option>
        </a-select>
      </a-form-item> -->

      <a-form-item label="标签名称:" name="tagName">
        <a-input
          placeholder="请输入标签名称"
          v-model:value="formState.tagName"
        ></a-input>
      </a-form-item>
      <a-form-item label="标签URL:" name="tagURL">
        <a-input
          placeholder="请输入URL"
          v-model:value="formState.tagURL"
        ></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script setup>
import { common_info_get } from 'server/modules/351.js'
import { reactive, ref, onMounted, computed, watch, defineEmits } from 'vue'
import useAPI from 'UseApi'
import { useRouter } from 'vue-router'
const APIS = useAPI(null, [4285])
const formRef = ref(null)
const router = useRouter()
const state = reactive({
  systemId: undefined,
  type: undefined,
  status: undefined,
  isShow: true,
  systems: [],
  dataSource: [],
  visible: false,
  typeObj: {
    2: '热门',
    3: '最新的'
  }
})
const formState = reactive({
  tagName: null,
  tagURL: null,
  systemName: null,
  systemId: null,
  type: 2
})
const params = computed(() => {
  return {
    type: state.type,
    status: state.status,
    systemId: state.systemId
  }
})
watch(
  () => params,
  () => {
    getList()
  },
  {
    deep: true
  }
)
const emits = defineEmits(['update:value'])
watch(
  () => state.isShow,
  val => {
    emits('update:value', val)
  }
)
const columns = [
  {
    title: '标签名称',
    dataIndex: 'tagName',
    key: 'tagName'
  },
  {
    title: '标签URL',
    dataIndex: 'tagURL',
    key: 'tagURL'
  },
  {
    title: '所属系统',
    dataIndex: 'systemName',
    key: 'systemName'
  },
  {
    title: '类型',
    dataIndex: 'type',
    key: 'type'
  },
  {
    title: '操作',
    key: 'action'
  }
]
const rules = {
  tagName: [
    { required: true, message: '名称不能为空', trigger: 'blur', type: 'any' }
  ],
  systemId: [
    {
      required: true,
      message: '请选择所属系统'
    }
  ]
}
// 初始化字典
const initSystems = async () => {
  const { success, data } = await common_info_get()
  if (success) {
    const { menuSystem } = data
    state.systems = menuSystem
  }
}
// 提交
const submit = () => {
  formRef.value.validate().then(() => {
    if (formState.id) {
      APIS.v1_hot_tag_update_post_(formState, state)
    } else {
      APIS.v1_hot_tag_create_post_(formState, state)
    }
  })
}
const filterOption = (input, option) => {
  return option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
}
// 切换系统
const onChange = (val, option) => {
  formState.systemName = option.name
}
const onDelete = id => {
  APIS.v1_hot_tag_delete_post_(id, state)
}
const setOnShelf = id => {
  // 设置上架
  APIS.v1_hot_tag_setOnShelf_post_(id, state)
}
const setOffShelf = id => {
  // 设置下架
  APIS.v1_hot_tag_setOffShelf_post_(id, state)
}
const getList = () => {
  APIS.v1_hot_tag_index_post_(state)
}
const onEdit = record => {
  Object.assign(formState, record)
  state.visible = true
}
onMounted(() => {
  initSystems()
  getList()
})
</script>
<style>
.ql-container {
  height: 300px;
}
.cursor {
  cursor: pointer;
}
</style>
